import React, { forwardRef, useRef } from 'react';

import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSTransition } from 'react-transition-group';

import './ContentPanel.scss';

type ContentPanelProps = {
  children?: React.ReactNode;
  onExpand?: () => void;
  onHide?: () => void;
  expanded?: boolean;
  showToggleButton?: boolean;
  unmountOnExit?: boolean;
  appear?: boolean;
};

export const ContentPanel = forwardRef(
  (
    { children, showToggleButton, expanded, unmountOnExit, appear = true, onExpand, onHide }: ContentPanelProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const internalRef = useRef(null);
    const refToUse = ref ?? internalRef;
    return (
      <CSSTransition
        nodeRef={refToUse}
        classNames={'slide-left-content-panel'}
        timeout={450}
        in={expanded}
        mountOnEnter={true}
        unmountOnExit={unmountOnExit}
        appear={appear}
      >
        <div ref={refToUse} className="content-panel">
          {showToggleButton && (
            <div className="content-panel__hide-toggle" onClick={expanded ? onHide : onExpand}>
              <FontAwesomeIcon icon={expanded ? light('chevron-double-right') : light('chevron-double-left')} />
            </div>
          )}
          {children}
        </div>
      </CSSTransition>
    );
  }
);
